<div class="prof">
  <div class="prof__main">
    <app-profile-form></app-profile-form>
    <app-change-password-form></app-change-password-form>
  </div>

  <!-- What this person's roles allow, so a missing button has an explanation -->
  <aside class="bk-panel access" aria-labelledby="access-title">
    <p class="bk-eyebrow">Your access</p>
    <h2 class="bk-heading access__title" id="access-title">What you can do</h2>

    @if (rolesKnown) {
      <ul class="access__roles" role="list">
        @for (role of roles; track role.name) {
          <li class="access__role">
            <span class="access__role-name">{{ role.label }}</span>
            @if (role.description) {
              <span class="access__role-desc">{{ role.description }}</span>
            }
          </li>
        } @empty {
          <li class="access__role">
            <span class="access__role-desc">You have no roles yet. Ask an administrator to give you one.</span>
          </li>
        }
      </ul>

      @for (group of groups; track group.title) {
        <section class="access__group">
          <h3 class="access__group-title">
            {{ group.title }}
            <span class="access__group-count">{{ group.allowedCount }} of {{ group.items.length }}</span>
          </h3>
          <ul class="access__list" role="list">
            @for (item of group.items; track item.label) {
              <li class="access__item" [class.is-off]="!item.allowed">
                <span class="bk-sym access__mark" aria-hidden="true">{{ item.allowed ? 'check' : 'remove' }}</span>
                <span>{{ item.label }}</span>
                @if (!item.allowed) {
                  <span class="bk-sr-only">(not included in your roles)</span>
                }
              </li>
            }
          </ul>
        </section>
      }

      <p class="access__note">
        Based on your roles. An administrator can change them on the Users tab.
      </p>
    } @else {
      <div class="access__skel" aria-hidden="true">
        <span class="bk-skel" style="height: 14px; width: 60%"></span>
        <span class="bk-skel" style="height: 12px; width: 90%"></span>
        <span class="bk-skel" style="height: 12px; width: 75%"></span>
        <span class="bk-skel" style="height: 12px; width: 82%"></span>
      </div>
      <p class="access__note">Your roles appear here once your profile loads.</p>
    }
  </aside>
</div>
